import { Fragment } from 'react';

import { Spinner } from '../Spinner';
import { StyledActionButton, StyledSpan } from './ActionButton.styled';

interface IActionButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
	src?: string;
	loading?: boolean;
}

const ActionButton = ({
	src,
	children,
	loading,
	...props
}: IActionButtonProps) => {
	return (
		<StyledActionButton {...props}>
			{loading ? (
				<Spinner />
			) : (
				<Fragment>
					{src && <img src={src} />}
					<StyledSpan>{children}</StyledSpan>
				</Fragment>
			)}
		</StyledActionButton>
	);
};

export { ActionButton };
